import { ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";
import { Location } from '@angular/common';
import { NavigationStateService } from "./modules/organization/services/dashboardClick.service";
import { LocalStorageService } from "./shared/services/local-storage/local-storage.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  title = "crm";
  // showLayout = true;

  // constructor(private router: Router) {
  //   this.router.events
  //     .pipe(filter(event => event instanceof NavigationEnd))
  //     .subscribe((event: any) => {
  //       const noLayoutRoutes = ['/', '/forgot-password'];
  //       this.showLayout = !noLayoutRoutes.includes(event.urlAfterRedirects);
  //     });
  // }
  private locationSub!: Subscription;

  constructor(
    private location: Location,
    // private navStateService: NavigationStateService,
    private localStorageService: LocalStorageService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) { }
  ngOnInit() {
    // this.location.subscribe((event: any) => {
    //   console.log('Browser nav button pressed:', event);
    //   // event.type: 'popstate' | 'hashchange'
    //   // event.url: the URL navigated to
    //   console.log("my info::", this.isDashboard())
    //   if (this.isDashboard()) {
    //     this.navigateToAdmin()
    //   }
    //   else {

    //     this.navigateToUser()
    //   }
    // });
  }

  // isDashboard(): boolean {
  //   const dashboards = ['/dashboard', '/dashboard2','organization'];
  //   return dashboards.includes(this.router.url);
  // }
  isDashboard(): boolean {
    const path = this.location.path(); // Returns: '/dashboard/1' (without #)
    console.log("location path:", path)
    return path.startsWith('/dashboard2') || path === '/dashboard2' || path === '/organization';
  }
  organizationInfo = ''
  navigateToAdmin(): void {
    this.organizationInfo = this.localStorageService.getLocalStorageItem('organizationInfo')

    console.log("organizationInfo detail:", this.organizationInfo)
    // this.navStateService.updateNav("1");
    const data = { type_id: 1 };
    this.localStorageService.setLocalStorageItem(
      'type_id',
      JSON.stringify(data.type_id)
    );

    // setTimeout(() => {
    //   this.localStorageService.setLocalStorageItem(
    //     "organizationInfo",
    //     ''
    //   );
    // }, 2000)
    // this.router.navigate(["/dashboard2"]);
  }
  navigateToUser(): void {
    this.organizationInfo = this.localStorageService.getLocalStorageItem('organizationInfo')

    console.log("organizationInfo detail:", this.organizationInfo)
    //this.navStateService.updateNav("2");
    const data = { type_id: 2 };
    this.localStorageService.setLocalStorageItem(
      'type_id',
      JSON.stringify(data.type_id)
    );
    // this.localStorageService.setLocalStorageItem(
    //   "organizationInfo",
    //   this.organizationInfo
    // );
    //this.cdr.detectChanges()
  }



}